import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/httpclient";
import { themes } from "../../sass/themes";
import { setCurrentTheme } from "./currentthemeslice";

export const logout = createAsyncThunk(
  "currentUser/logout",
  async (props, thunkApi) => {
    var dispatch = thunkApi.dispatch;
    var state = thunkApi.getState();
    console.log("state", state);

    try {
      var response = await api({
        url: "auth/logout",
        method: "post",
        data: {},
        headers: {
          "vasbi-cookie-refreshtoken": `${state.currentUser.RefreshToken}`,
          "x-refreshtoken": `${state.currentUser.RefreshToken}`,
        },
      });

      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
      //it's ok to dispatch here
      dispatch(
        currentUserSlice.actions.setCurrentUser({ IsAuthenticated: false })
      );

      dispatch(setCurrentTheme(themes["2"]));

      return response;
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false, 401, 500 etc. this will invoke .rejected
      return thunkApi.rejectWithValue(err);
    }
  }
);

const currentUserSlice = createSlice({
  name: "currentUser",
  initialState: {
    IsAuthenticated: false,
    paymentMessage: "",
    paymentNotifVisibility: false,
  },
  reducers: {
    setCurrentUser: (state, action) => {
      return action.payload;
    },

    setFirstLoginCompleted: (state, action) => {
      return {
        ...state,
        Subscription: {
          ...state.Subscription,
          FirstLoginCompleted: action.payload,
        },
      };
    },    

    setClosePaymentNotification: (state, action) => {
      return {
        ...state,
        paymentNotifVisibility: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout.pending, (state, action) => {})
      .addCase(logout.fulfilled, (state, action) => {
        state = { IsAuthenticated: false };
      })
      .addCase(logout.rejected, (state, action) => {});
  },
});

export const { setCurrentUser, setClosePaymentNotification , setFirstLoginCompleted} =
  currentUserSlice.actions;

export const changePassword =
  (oldPassword, password, passwordConfirmed) => async (dispatch, getState) => {
    //show loader
    //dispatch(setProcessing({processing: true, processingText: "Changing Password..."}));

    try {
      var response = await api({
        url: "auth/changepassword",
        method: "post",
        data: {
          oldPassword: oldPassword,
          password: password,
          passwordConfirmed: passwordConfirmed,
        },
        //headers:{'h':'1'}
      });

      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false
      return Promise.reject(err);
    }
  };

export default currentUserSlice.reducer;
